import request from '@/util/request'

export function countNeedPay(query) {
  return request({
    url: '/order/countNeedPay',
    method: 'get',
    params: query,
  })
}

export function countByStatus(query) {
  return request({
    url: '/order/countByStatus',
    method: 'get',
    params: query,
  })
}

export function listOrders(query) {
  return request({
    url: '/order/list',
    method: 'get',
    params: query,
  })
}

export function orderAddressHistory(query) {
  return request({
    url: '/order/history/address',
    method: 'get',
    params: query,
  })
}

export function generateOrder(data) {
  return request({
    url: '/order/generate',
    method: 'post',
    data,
  })
}

export function cancelOrder(data) {
  return request({
    url: '/order/cancel',
    method: 'post',
    data,
  })
}

export function payOrder(data) {
  return request({
    url: '/order/pay',
    method: 'post',
    data,
  })
}

export function batchPayOrder(data) {
  return request({
    url: '/order/batchPay',
    method: 'post',
    data,
  })
}

export function setBalanceAccount(data) {
  return request({
    url: '/order/setBalanceAccount',
    method: 'post',
    data,
  })
}

export function setBalanceBill(data) {
  return request({
    url: '/order/setBalanceBill',
    method: 'post',
    data,
  })
}

export function payBalanceByStarPay(data) {
  return request({
    url: '/order/payBalanceByStarPay',
    method: 'post',
    data,
  })
}

export function setAddressAndLogistics(data) {
  return request({
    url: '/order/setAddressAndLogistics',
    method: 'post',
    data,
  })
}
